module.exports = __webpack_public_path__ + "img/the-red-yeti.1cfe6fc6.svg";